// extracted by mini-css-extract-plugin
export default {"footer-dimension":"Footer_footer-dimension__H1tcf","menu-item-active":"Footer_menu-item-active__9oykK","active-menu-text":"Footer_active-menu-text__qvIp6"};